import { Button, Form, Input } from 'antd'
import axios from 'axios'
import React, { useRef, useState } from 'react'
import { AUTH } from '../../../utils/apis'
import { errorMessage, successMessage } from '../../../utils/helpers'

const ChangePassword = (props) => {
    const { history, user, authActions, language, selectedLanguage } = props
    const [loading, setLoading] = useState(false)
    const antdForm = useRef(null)
    const onFinish = (values) => {
        values = { ...values, ...user }
        setLoading(true)
        axios.post(AUTH.CHANGE_DOCTOR_PASSWORD, values)
            .then((res) => {
                const { data } = res
                setLoading(false)
                if (data.success) {
                    successMessage(selectedLanguage?.backendMessage_PasswordSuccessfullyUpdated)
                    antdForm.current.resetFields(['password', 'newPassword', 'confirm'])
                    return authActions.loginUser(data.user)
                }
                errorMessage(data.message/* assignMessage(data.message, language?.language) */)
            })
            .catch((e) => {
                console.log('error', e)
                setLoading(false)
                errorMessage(e.message/* assignMessage(e.message, language?.language) */)
            })
    }
    return (
        <div className="second-design-service-container">
            <div className="service-top-div">
                <div>
                    <h1>{selectedLanguage?.txt_security}</h1>
                </div>
            </div>
            <div className="appointment-form-container">
                <Form
                    name='form'
                    onFinish={onFinish}
                    layout={'vertical'}
                    requiredMark={false}
                    ref={antdForm}
                >
                    <div className='form-two-input-flex'>
                        <div className='form-two-input-flex-inner-input'>
                            <Form.Item
                                name='password'
                                label={selectedLanguage?.txt_current_password}
                                rules={[
                                    {
                                        required: true,
                                        message: selectedLanguage?.txt_please_input_your_current_password
                                    },
                                    {
                                        min: 6,
                                        message: selectedLanguage?.txt_password_must_be_atleast_characters
                                    }
                                ]}
                            >
                                <Input.Password
                                    className='form-input-new-style'
                                    placeholder={selectedLanguage?.txt_please_input_your_current_password}
                                />
                            </Form.Item>
                        </div>
                        <div className='form-two-input-flex-inner-input'>
                            <Form.Item
                                name='newPassword'
                                label={selectedLanguage?.txt_new_password}
                                rules={[
                                    {
                                        required: true,
                                        message: selectedLanguage?.txt_please_input_your_new_password
                                    },
                                    {
                                        min: 6,
                                        message: selectedLanguage?.txt_password_must_be_atleast_characters
                                    }
                                ]}
                            >
                                <Input.Password
                                    className='form-input-new-style'
                                    placeholder={selectedLanguage?.txt_please_input_your_new_password}
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <div className='form-input-single-input'>
                        <Form.Item
                            name='confirm'
                            label={selectedLanguage?.txt_confirm_password}
                            hasFeedback
                            rules={[
                                {
                                    required: true,
                                    message: selectedLanguage?.txt_please_input_your_Confirm,
                                },
                                ({ getFieldValue }) => ({
                                    validator(rule, value) {
                                        if (!value || getFieldValue('newPassword') === value) {
                                            return Promise.resolve()
                                        }
                                        return Promise.reject(selectedLanguage?.txt_two_passwords_that_you_entered_do_not_match)
                                    },
                                })
                            ]}
                        >
                            <Input.Password
                                placeholder={selectedLanguage?.txt_please_input_your_Confirm_password}
                                className='form-input-new-style'
                            />
                        </Form.Item>
                    </div>
                    <Form.Item>
                        <Button style={{ marginTop: '10px', height: '45px' }}
                            className='new-button-for-profile'
                            htmlType='submit'
                            loading={loading}
                            type='primary'
                        >
                            {selectedLanguage?.txt_update_password}
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    )
}

export default ChangePassword